export default __webpack_public_path__ + "static/media/Myntra_Footer.95569e4b.png";